import { useCallback, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./TriviaCoco.module.css";
import ProgressBar from "../components/ProgressBar";
import Trivia from "../components/Trivia";
import NavPanel from "../components/NavPanel";
import NBLogoWhite from "../components/NBLogoWhite";

const TriviaCoco = () => {
  const navigate = useNavigate();

  const [correctedAnswer, setCorrectedAnswer] = useState(false);

  const videoRef = useRef(null);

  const checkoutCloset = useCallback(() => {
    navigate("/coco-closet");
  }, [navigate]);


  const previousPage = useCallback(() => {
    navigate("/who-best");
  }, [navigate]);
  
  const onCorrect = (value) => {
    setCorrectedAnswer(value)

    if(videoRef.current) {
      if (value) {
        videoRef.current.play();
      } else {
        videoRef.current.pause();
        videoRef.current.currentTime = 0;
      }
    }
  }

  const choices = [
    { number: 'A', answer: '12', correct: false },
    { number: 'B', answer: '14', correct: true },
    { number: 'C', answer: '16', correct: false },
    { number: 'D', answer: '18', correct: false }
  ]
  const question = 'What age did Coco Gauff turn pro?'
  const message = 'Coco Gauff turned pro at just 14 years old, quickly becoming one of the most talked-about young stars in tennis.'
  const correct = 'B'
  const title = 'Nope.'

  return (
    <div className={styles.cocoTrivia}>
      <NavPanel onClick={previousPage} />
      <NavPanel postion='right' onClick={checkoutCloset} />
      <ProgressBar current='2' />
      <div className={styles.gradient}></div>
      <NBLogoWhite/ >

      <div className={styles.player}>
        <video 
          src="applause.mp4" 
          playsInline
          loop
          ref={videoRef}
          style={{
            height: '100%',
            width: '100%',
            objectFit: 'cover'
          }}
          className={correctedAnswer ? '' : 'hide'}
        />

        { !correctedAnswer && <img className={styles.cocoImage} src='coco_trivia.png'></img> }     
      </div>
      
      <div className={styles.frameParent}>
        <Trivia
          question={question}
          choices={choices}
          question_id={5}
          info={message}
          onCorrect={onCorrect}
          wrongTitle = {title}
        />
      </div>
      <div className={styles.checkoutButton} >
        <div className= {styles.question} onClick={checkoutCloset} >
          Check out Coco Gauff's Closet ➔
        </div>
      </div>
    </div>
  )
}
export default TriviaCoco;
